import { Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

export const TermsAndPrivacyFooter: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <footer className={classes.footer}>
      <Typography color="textSecondary">
        UpLift <a href={l10n.general.termsUrl} target="_blank" rel="noreferrer">
          Terms of Service
        </a> and <a href={l10n.general.privacyUrl} target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
      </Typography>
    </footer>
  );
};

const useStyles = makeStyles({ name: 'OnboardingFooter' })(theme => ({
  footer: {
    boxSizing: 'border-box',
    color: theme.palette.text.secondary,
    display: 'flex',
    height: '40px',
    justifyContent: 'center',
    padding: theme.spacing(1, 3),
    width: '100%',
    '& p': {
      fontSize: '12px',
    },
    '& a': {
      color: theme.palette.text.secondary,
    },
    [theme.breakpoints.up('sm')]: {
      borderTop: `1px solid ${theme.palette.divider}`,
    }
  },
}));
